import { mapRange } from "../../utils";
import { ActorItem, Actor } from "../base";
class CustomItem extends ActorItem {
    source;
    interpolate(n) {
        for (const x in this.input) {
            const i = this.input[x];
            const fn = i.interpolate ?? CustomActor.interpolate;
            i.current = fn(n, i.from, i.to ?? i.from);
        }
        return this.input;
    }
    set(input, timing) {
        const merged = { ...this.input };
        for (const x in input)
            if (x in this.input)
                Object.assign(merged, {
                    [x]: {
                        ...this.input[x],
                        from: this.input[x].current ?? this.input[x].from,
                        to: input[x],
                    }
                });
        super.set(merged, timing);
        return this;
    }
}
export class CustomActor extends Actor {
    current;
    _apply;
    constructor(apply) {
        super();
        this._apply = apply;
        this.current = {};
    }
    createItem(target, timing) {
        const item = new CustomItem(target, timing);
        item.source = { ...this.current };
        return item;
    }
    interpolate(now) {
        if (this.done)
            return;
        for (const item of this.items)
            item.update(now);
        const merged = {};
        for (const item of this.items)
            for (const x in item.current) {
                if (merged[x] === undefined || item.started)
                    merged[x] = item.current[x];
            }
        for (const x in merged)
            this.current[x] = merged[x].format?.(merged[x].current) ?? merged[x].current;
        this._apply?.(this.current);
    }
    apply(fn) {
        this._apply = fn;
        return this;
    }
    destroy() {
        this.current = {};
        return super.destroy();
    }
    prop(k) {
        return this.current[k];
    }
    static interpolate(n, start, end) {
        return mapRange(n, [0, 1], [start, end]);
    }
    static map = new Map();
    static get(key) {
        let i = CustomActor.map.get(key);
        if (!i) {
            i = new CustomActor();
            CustomActor.map.set(key, i);
        }
        return i;
    }
}
